import Vue from 'vue'

// 图片裁剪
Vue.filter('imgResize', (url, opts) => {
  if (typeof url !== 'string') return url

  const urlParse = url.match(/^([^?]+\??)(.+)?$/) || []
  // keep original query params
  const urlQs = urlParse[2]
  let uri = urlParse[1]

  uri += urlQs ? '&' : '?'
  uri += `op=imageView2&${opts}`

  return uri
})
